const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api';

class ApiClient {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    // Agregar token de autenticación si existe
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(url, config);
    
    // Manejar errores 403 específicamente
    if (response.status === 403) {
      try {
        const errorData = await response.json();
        const message = errorData.error || errorData.message || 'No tienes permisos para realizar esta acción';
        console.warn('🚫 Acceso denegado:', message);
        // Podrías mostrar una notificación aquí si tienes un sistema de notificaciones global
      } catch (parseError) {
        console.warn('🚫 Acceso denegado: No tienes permisos para realizar esta acción');
      }
    }
    
    return response;
  }

  async get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  async post(endpoint, data, options = {}) {
    console.log('📤 ApiClient POST:', {
      endpoint,
      data,
      dataStringified: JSON.stringify(data)
    });
    
    return this.request(endpoint, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async delete(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'DELETE' });
  }
}

const apiClient = new ApiClient();
export default apiClient;